/**
 * Frontend error registry: keys are sent to Sentry as `tags.error_code`;
 * values are human-readable descriptions (`tags.error_code_desc` via trackError).
 */
export const APP_ERROR_CODES = {
  FE_0001: 'API HTTP request failed (axios / RTK base query)',

  FE_0002: 'Failed to accept terms of use',

  FE_0003: 'WebRTC camera initialization failed',
  FE_0004: 'WebRTC camera reconnection failed',
  FE_0005: 'Failed to add WebRTC ICE candidate',

  FE_0006: 'File download failed (DOM / programmatic click)',

  FE_0007: 'Map geocoding failed (right-click / double-click)',
  FE_0008: 'Reverse geocoding failed (marker drag, zone drop, mission point)',
  FE_0009: 'Drone map search by address: geocode failed',
  FE_0010: 'Drone map search by coordinates: geocode failed',

  FE_0011: 'Geolocation / Find me failed',

  FE_0012: 'Google Search Input: geocode failed',
  FE_0013: 'Arc Google Search: geocode failed',

  FE_0014: 'Weather socket: JSON parse failed',

  FE_0015: 'Main Arc WebSocket: JSON message parse failed',

  FE_0016: 'Integration (JWT keys): mutation failed in UI',

  FE_0017: 'Zones: mutation failed in UI (popup / form)',

  FE_0018: 'Settings: mutation failed in UI (users, parameters, password)',

  FE_0019: 'Profile: mutation failed in UI',

  FE_0020: 'Orders / missions: mutation failed in UI',

  FE_0021: 'Fleet: mutation failed in UI',

  FE_0022: 'Auth: client flow failed in UI (sign-in, verify, reset, activate)',

  FE_0023: 'Drone UI action failed (take-off mutation, RTK NTRIP save)',

  FE_0024: 'Controller / joystick: camera settings JSON parse failed',

  /** Fallback for Sentry events without an explicit `trackError` code (unhandled errors, integrations, etc.) */
  FE_0025: 'Uncategorized frontend error (automatic Sentry capture, no trackError code)',

  /** React `Sentry.ErrorBoundary` / render-tree crash (SDK mechanism `react.error_boundary`) */
  FE_0026: 'React UI crashed (Error Boundary)',
} as const;

export type AppErrorCode = keyof typeof APP_ERROR_CODES;
